// Textos de las pantallas públicas: landing, login/registro y tutorial.
// Mismas claves en los tres idiomas; el español es el texto de referencia.
// Prefijos: landing… (LandingPage.js), login… (Login.js), tuto… (TutorialWizard.js).
// Los textos con variables usan {nombre} y se resuelven con tf('clave', { nombre }).
export const publico = {
  es: {
    // --- Landing: cabecera ---
    landingNavFeatures: 'Funcionalidades',
    landingNavDashboard: 'Dashboard',
    landingNavHowItWorks: 'Cómo Funciona',
    landingSignIn: 'Iniciar Sesión',
    // --- Landing: hero ---
    landingHeroTitle1: 'Construye tu',
    landingHeroTitle2: 'Futuro Financiero',
    landingHeroText: 'La herramienta definitiva para gestionar tu presupuesto personal, analizar tu patrimonio neto y alcanzar la libertad financiera con datos claros y potentes visualizaciones.',
    landingRegisterFree: 'Regístrate Gratis',
    // --- Landing: funcionalidades ---
    landingFeaturesTitle1: 'Herramientas',
    landingFeaturesTitle2: 'Potentes y Claras',
    landingFeaturesText: 'Funcionalidades diseñadas para que cada decisión financiera sea más inteligente y sencilla.',
    landingFeat1Title: 'Presupuestos Flexibles',
    landingFeat1Text: 'Define presupuestos anuales con categorías y subcategorías personalizables. Calcula tu "remanente" mensual y ajusta tus gastos sobre la marcha para un control total.',
    landingFeat2Title: 'Análisis de Patrimonio Neto',
    landingFeat2Text: 'Registra tus activos y pasivos mes a mes. Observa la evolución de tu patrimonio neto con gráficos de línea interactivos, identificando tendencias y tu verdadera riqueza.',
    landingFeat3Title: 'Seguimiento Mensual Detallado',
    landingFeat3Text: 'Registra tus ingresos y gastos reales y compáralos instantáneamente con tu presupuesto. Visualiza la distribución de tus egresos con gráficos de tarta y barras.',
    landingFeat4Title: 'Gestión de Préstamos y Amortización',
    landingFeat4Text: 'Visualiza el calendario de amortización de tus préstamos. Realiza amortizaciones parciales y observa cómo impactan en tu balance y la duración de tus deudas.',
    // --- Landing: vista previa del dashboard ---
    landingPreviewTitle1: 'Tu',
    landingPreviewTitle2: 'Centro de Mando Financiero',
    landingPreviewText: 'Una interfaz intuitiva, potente y con toda la información que importa de un solo vistazo. Así se ve el control.',
    landingTabCharts: 'Gráficos',
    landingTabLoan: 'Préstamo Ejemplo',
    landingLoanSummary: 'Préstamo: 150k€ | 30 años | 3.5% Int.',
    landingNetWorthEvolution: 'Evolución Anual del Patrimonio Neto',
    landingExpenseDistribution: 'Distribución de Egresos ({month})',
    landingMonthSummary: 'Resumen del Mes (Actual)',
    landingActualIncome: 'Ingresos Reales:',
    landingActualExpenses: 'Gastos Reales:',
    landingRemainder: 'Remanente:',
    landingBudgetVsActual: 'Comparativa Presupuesto vs. Real ({month})',
    landingAmortizationSchedule: 'Calendario de Amortización',
    landingLoanDisclaimer: '*Esta es una simulación de ejemplo. La aplicación permite añadir tus propios préstamos, visualizar su calendario de amortización detallado y registrar pagos anticipados.',
    // --- Landing: gráficos de ejemplo ---
    landingNetWorth: 'Patrimonio Neto',
    landingAssets: 'Activos',
    landingLiabilities: 'Pasivos',
    landingPieEssential: 'Gastos Esenciales',
    landingPieDiscretionary: 'Gastos Discrecionales',
    landingPieDebt: 'Pago de Deudas',
    landingPieSavings: 'Ahorro',
    // --- Landing: tabla presupuesto vs. real ---
    landingColCategory: 'Categoría',
    landingColBudgeted: 'Presupuestado',
    landingColActual: 'Real',
    landingColDifference: 'Diferencia',
    landingRowRent: 'Alquiler',
    landingRowFood: 'Comida',
    landingRowTransport: 'Transporte',
    landingRowTotalExpenses: 'Total Gastos',
    // --- Landing: tabla de amortización ---
    landingFixedMonthlyPayment: 'Pago Mensual Fijo: {amount}',
    landingColMonth: 'Mes',
    landingColInterest: 'Intereses',
    landingColPrincipal: 'Principal',
    landingColAmortized: 'Capital Amort.',
    landingColPending: 'Capital Pdte.',
    // --- Landing: cómo funciona ---
    landingHowTitle1: 'Empieza a Gestionar tus Finanzas en',
    landingHowTitle2: '3 Simples Pasos',
    landingHowText: 'Toma el control de tu dinero de forma rápida, intuitiva y eficaz, tal como lo haces en tu vida diaria.',
    landingStep1Title: '1. Define tu Presupuesto',
    landingStep1Text: 'Personaliza tus categorías y subcategorías. Asigna montos a tus ingresos y gastos esperados para el año.',
    landingStep2Title: '2. Registra con Facilidad',
    landingStep2Text: 'Usa el formulario de registro rápido mensual para añadir tus gastos e ingresos diarios en cuestión de segundos.',
    landingStep3Title: '3. Analiza y Crece',
    landingStep3Text: 'Visualiza tu remanente, compara lo real con lo presupuestado y mira tu patrimonio neto crecer a lo largo del tiempo.',
    // --- Landing: pie ---
    landingFooterTagline: 'Controla tu futuro financiero.',

    // --- Login / registro ---
    loginSubtitle: 'Gestión de finanzas personales',
    loginSignIn: 'Iniciar Sesión',
    loginRegister: 'Regístrate',
    loginName: 'Nombre',
    loginNamePlaceholder: 'Tu nombre',
    loginEmail: 'Email',
    loginEmailPlaceholder: 'ejemplo@correo.com',
    loginPassword: 'Contraseña',
    loginRepeatPassword: 'Repetir Contraseña',
    loginLoading: 'Cargando...',
    loginCreateAccount: 'Crear Cuenta',
    loginOrSignInWith: 'O INICIA SESIÓN CON',
    loginBackHome: '← Volver al inicio',
    loginErrFirebaseNotReady: 'Firebase Auth/DB no inicializada aún',
    loginErrBadCredentials: 'Credenciales incorrectas. Verifica tu email y contraseña.',
    loginErrPasswordLength: 'La contraseña debe tener al menos 8 caracteres.',
    loginErrPasswordMismatch: 'Las contraseñas no coinciden.',
    loginErrEmailInUse: 'Este email ya está registrado. Por favor, inicia sesión.',
    loginErrUnknown: 'Error desconocido en Firebase',
    loginErrAuth: 'Error en la autenticación: {msg}',
    loginErrFirebaseConfig: 'Firebase no está configurado correctamente. Revisa src/firebase.js',
    loginErrGoogle: 'Error al iniciar sesión con Google: {msg}',

    // --- Tutorial ---
    tutoStep1Title: 'Menú Lateral de Secciones 🧭',
    tutoStep1Content: 'Toda la navegación está estructurada por módulos. Desde aquí puedes acceder al registro de meses, balances anuales, ajustes y calculadoras patrimoniales de intereses compuestos.',
    tutoStep2Title: 'El Tiempo es la Clave ⏳',
    tutoStep2Content: 'Este selector viaja en el tiempo. Selecciona el año en el que quieres operar. De serie se proyectan datos 10 años al pasado o futuro si es que has operado allí. Usa el tiempo sabiamente para simular presupuestos.',
    tutoStep3Title: 'Tu Dashboard, a tu manera 🧩',
    tutoStep3Content: 'Pulsa "Personalizar" para decidir qué bloques ves y en qué orden y tamaño: salud financiera, ahorro acumulado frente al plan, objetivo de ahorro anual, dónde se va el dinero, la evolución de una categoría o la comparativa con el año anterior. La disposición se guarda en tu cuenta y la verás igual en cualquier dispositivo.',
    tutoStep4Title: 'Presupuesto y seguimiento 📊',
    tutoStep4Content: 'Seguimiento Mensual tiene dos pestañas arriba: Seguimiento (lo real, mes a mes) y Presupuesto (el plan del año, con sus categorías y los gastos puntuales). Haz clic en "Presupuesto" para continuar y ver cómo cambia.',
    tutoStep5Title: 'Día a Día (El flujo Mensual) 📅',
    tutoStep5Content: 'Tu "hoja clínica" del mes, todo en la misma tabla: haz clic en la cifra Real de una categoría y escribe el total (se crea o ajusta un movimiento para que cuadre), y haz clic en el nombre de la categoría (▸) para ver sus movimientos, añadirlos con fecha, concepto e importe, editarlos o borrarlos. El estimado es tu presupuesto y se edita en la pestaña Presupuesto de esta misma sección.',
    tutoStep6Title: 'Activos, Pasivos y Ahorros 🏦',
    tutoStep6Content: 'Esto no es un gasto cotidiano, ¡es el inventario de lo que posees y debes! Guarda aquí el saldo del banco, o el valor de la vivienda y mantén tracking de cómo te vuelves más rico a través del tiempo.',
    tutoStep7Title: 'Categorías Inteligentes ⚙️',
    tutoStep7Content: 'En "Ajustes", al crear o borrar categorías aplican ÚNICAMENTE al año seleccionado en adelante. Protegiendo tu pasado sin alterarlo. Muy superior al sistema clásico.',
    tutoStep8Title: '¡Añade Tus Propios Datos! 🚀',
    tutoStep8Content: 'Para que FinanziApp rinda, empieza creando tus límites en el Presupuesto, actualiza tus saldos en Patrimonio Neto y deja el Dashboard con los bloques que te interesen. ¡Tú diriges tu economía!',
    tutoStepOf: 'PASO {n} DE {total}',
    tutoSkip: 'Saltar',
    tutoBack: 'Atrás',
    tutoLetsGo: '¡Vamos Allá!',
    tutoNext: 'Siguiente',
    tutoInteract: 'Interactúa para seguir',
    // ─── Registro profesional: verificación, contraseña con Google, recuperar ───
    loginCompletarTitulo: 'Completa tu registro',
    loginCompletarTexto: 'Para proteger tu cuenta, crea una contraseña. Así también podrás entrar con tu correo cuando no uses Google.',
    loginCompletarBtn: 'Guardar y entrar',
    loginCancelar: 'Cancelar',
    loginVerificarTitulo: 'Verifica tu correo',
    loginVerificarTexto: 'Te hemos enviado un correo a {email} con un enlace para activar tu cuenta. Ábrelo y vuelve aquí: entrarás automáticamente. Si no lo ves, mira en spam.',
    loginVerificarComprobar: 'Ya lo he verificado',
    loginVerificarReenviar: 'Reenviar correo',
    loginVerificarReenviado: 'Correo reenviado. Revisa también la carpeta de spam.',
    loginVerificarPendiente: 'Todavía no aparece como verificado. Abre el enlace del correo y vuelve a intentarlo.',
    loginVerificarOtra: 'Usar otra cuenta',
    loginOlvide: '¿Has olvidado tu contraseña?',
    loginResetEnviado: 'Si ese correo tiene cuenta, te hemos enviado un enlace para restablecer la contraseña.',
    loginResetSinCorreo: 'Escribe tu correo arriba y vuelve a pulsar.',
    loginErrReciente: 'Por seguridad, vuelve a entrar con Google y repite este paso.',
    tutoStepPresuTitle: 'Configura tu presupuesto 🧮',
    tutoStepPresuContent: 'Pulsa "Desbloquear Edición" para cambiar las cantidades mensuales de cada categoría (son el estimado que verás en Seguimiento). El "+" de cada bloque añade una categoría y, con la edición abierta, cada fila tiene su papelera para quitarla. Abajo, "Gastos puntuales" recoge lo que no se repite cada mes. Cuando termines, vuelve a bloquear para no tocar nada sin querer.',
  },
  en: {
    // --- Landing: header ---
    landingNavFeatures: 'Features',
    landingNavDashboard: 'Dashboard',
    landingNavHowItWorks: 'How It Works',
    landingSignIn: 'Sign In',
    // --- Landing: hero ---
    landingHeroTitle1: 'Build Your',
    landingHeroTitle2: 'Financial Future',
    landingHeroText: 'The ultimate tool to manage your personal budget, analyse your net worth and reach financial freedom with clear data and powerful visualisations.',
    landingRegisterFree: 'Sign Up for Free',
    // --- Landing: features ---
    landingFeaturesTitle1: 'Tools That Are',
    landingFeaturesTitle2: 'Powerful and Clear',
    landingFeaturesText: 'Features designed to make every financial decision smarter and simpler.',
    landingFeat1Title: 'Flexible Budgets',
    landingFeat1Text: 'Set annual budgets with customisable categories and subcategories. Calculate your monthly "remainder" and adjust your spending on the fly for total control.',
    landingFeat2Title: 'Net Worth Analysis',
    landingFeat2Text: 'Record your assets and liabilities month by month. Watch your net worth evolve with interactive line charts, spotting trends and your true wealth.',
    landingFeat3Title: 'Detailed Monthly Tracking',
    landingFeat3Text: 'Record your actual income and expenses and compare them instantly with your budget. Visualise how your spending is distributed with pie and bar charts.',
    landingFeat4Title: 'Loan and Amortization Management',
    landingFeat4Text: 'View the amortization schedule of your loans. Make partial repayments and see how they affect your balance and the duration of your debts.',
    // --- Landing: dashboard preview ---
    landingPreviewTitle1: 'Your',
    landingPreviewTitle2: 'Financial Command Centre',
    landingPreviewText: 'An intuitive, powerful interface with all the information that matters at a glance. This is what control looks like.',
    landingTabCharts: 'Charts',
    landingTabLoan: 'Sample Loan',
    landingLoanSummary: 'Loan: €150k | 30 years | 3.5% int.',
    landingNetWorthEvolution: 'Annual Net Worth Evolution',
    landingExpenseDistribution: 'Expense Distribution ({month})',
    landingMonthSummary: 'Month Summary (Current)',
    landingActualIncome: 'Actual Income:',
    landingActualExpenses: 'Actual Expenses:',
    landingRemainder: 'Remainder:',
    landingBudgetVsActual: 'Budget vs. Actual Comparison ({month})',
    landingAmortizationSchedule: 'Amortization Schedule',
    landingLoanDisclaimer: '*This is a sample simulation. The app lets you add your own loans, view their detailed amortization schedule and record early repayments.',
    // --- Landing: sample charts ---
    landingNetWorth: 'Net Worth',
    landingAssets: 'Assets',
    landingLiabilities: 'Liabilities',
    landingPieEssential: 'Essential Expenses',
    landingPieDiscretionary: 'Discretionary Expenses',
    landingPieDebt: 'Debt Payments',
    landingPieSavings: 'Savings',
    // --- Landing: budget vs. actual table ---
    landingColCategory: 'Category',
    landingColBudgeted: 'Budgeted',
    landingColActual: 'Actual',
    landingColDifference: 'Difference',
    landingRowRent: 'Rent',
    landingRowFood: 'Food',
    landingRowTransport: 'Transport',
    landingRowTotalExpenses: 'Total Expenses',
    // --- Landing: amortization table ---
    landingFixedMonthlyPayment: 'Fixed Monthly Payment: {amount}',
    landingColMonth: 'Month',
    landingColInterest: 'Interest',
    landingColPrincipal: 'Principal',
    landingColAmortized: 'Amortized',
    landingColPending: 'Outstanding',
    // --- Landing: how it works ---
    landingHowTitle1: 'Start Managing Your Finances in',
    landingHowTitle2: '3 Simple Steps',
    landingHowText: 'Take control of your money quickly, intuitively and effectively, just as you do in your daily life.',
    landingStep1Title: '1. Set Your Budget',
    landingStep1Text: 'Customise your categories and subcategories. Assign amounts to your expected income and expenses for the year.',
    landingStep2Title: '2. Record with Ease',
    landingStep2Text: 'Use the quick monthly entry form to add your daily expenses and income in seconds.',
    landingStep3Title: '3. Analyse and Grow',
    landingStep3Text: 'View your remainder, compare actuals with your budget and watch your net worth grow over time.',
    // --- Landing: footer ---
    landingFooterTagline: 'Take control of your financial future.',

    // --- Login / sign-up ---
    loginSubtitle: 'Personal finance management',
    loginSignIn: 'Sign In',
    loginRegister: 'Sign Up',
    loginName: 'Name',
    loginNamePlaceholder: 'Your name',
    loginEmail: 'Email',
    loginEmailPlaceholder: 'example@email.com',
    loginPassword: 'Password',
    loginRepeatPassword: 'Repeat Password',
    loginLoading: 'Loading...',
    loginCreateAccount: 'Create Account',
    loginOrSignInWith: 'OR SIGN IN WITH',
    loginBackHome: '← Back to home',
    loginErrFirebaseNotReady: 'Firebase Auth/DB not initialised yet',
    loginErrBadCredentials: 'Incorrect credentials. Check your email and password.',
    loginErrPasswordLength: 'The password must be at least 8 characters long.',
    loginErrPasswordMismatch: 'The passwords do not match.',
    loginErrEmailInUse: 'This email is already registered. Please sign in.',
    loginErrUnknown: 'Unknown Firebase error',
    loginErrAuth: 'Authentication error: {msg}',
    loginErrFirebaseConfig: 'Firebase is not configured correctly. Check src/firebase.js',
    loginErrGoogle: 'Error signing in with Google: {msg}',

    // --- Tutorial ---
    tutoStep1Title: 'Side Menu of Sections 🧭',
    tutoStep1Content: 'All navigation is organised by modules. From here you can access the monthly records, annual balances, settings and compound-interest wealth calculators.',
    tutoStep2Title: 'Time Is the Key ⏳',
    tutoStep2Content: 'This selector travels through time. Choose the year you want to work in. By default, data is projected 10 years into the past or future if you have worked there. Use time wisely to simulate budgets.',
    tutoStep3Title: 'Your Dashboard, Your Way 🧩',
    tutoStep3Content: 'Click "Customise" to decide which blocks you see and in what order and size: financial health, accumulated savings vs. plan, annual savings goal, where the money goes, the evolution of a category or the comparison with the previous year. The layout is saved to your account and looks the same on any device.',
    tutoStep4Title: 'Budget and tracking 📊',
    tutoStep4Content: 'Monthly Tracker has two tabs at the top: Tracking (actuals, month by month) and Budget (the plan for the year, with its categories and one-time expenses). Click "Budget" to continue and see how it changes.',
    tutoStep5Title: 'Day to Day (The Monthly Flow) 📅',
    tutoStep5Content: 'Your month\'s "medical chart", all in one table: click a category\'s Actual figure and type the total (a transaction is created or adjusted so it matches), and click the category name (▸) to see its transactions, add them with date, note and amount, edit or delete them. The estimate is your budget and is edited in the Budget tab of this same section.',
    tutoStep6Title: 'Assets, Liabilities and Savings 🏦',
    tutoStep6Content: 'This is not an everyday expense, it is the inventory of what you own and owe! Store your bank balance or the value of your home here and keep track of how you get richer over time.',
    tutoStep7Title: 'Smart Categories ⚙️',
    tutoStep7Content: 'In "Settings", creating or deleting categories applies ONLY from the selected year onwards. Protecting your past without altering it. Far superior to the classic system.',
    tutoStep8Title: 'Add Your Own Data! 🚀',
    tutoStep8Content: 'To get the most out of FinanziApp, start by setting your limits in the Budget, update your balances in Net Worth and arrange the Dashboard with the blocks you care about. You are in charge of your finances!',
    tutoStepOf: 'STEP {n} OF {total}',
    tutoSkip: 'Skip',
    tutoBack: 'Back',
    tutoLetsGo: "Let's Go!",
    tutoNext: 'Next',
    tutoInteract: 'Interact to continue',
    // ─── Professional sign-up: verification, password with Google, recovery ───
    loginCompletarTitulo: 'Complete your sign-up',
    loginCompletarTexto: 'To protect your account, create a password. You will also be able to sign in with your email when you are not using Google.',
    loginCompletarBtn: 'Save and enter',
    loginCancelar: 'Cancel',
    loginVerificarTitulo: 'Verify your email',
    loginVerificarTexto: 'We have sent an email to {email} with a link to activate your account. Open it and come back here: you will be signed in automatically. Check your spam folder if you cannot see it.',
    loginVerificarComprobar: 'I have verified it',
    loginVerificarReenviar: 'Resend email',
    loginVerificarReenviado: 'Email resent. Check your spam folder too.',
    loginVerificarPendiente: 'It does not show as verified yet. Open the link in the email and try again.',
    loginVerificarOtra: 'Use another account',
    loginOlvide: 'Forgot your password?',
    loginResetEnviado: 'If that email has an account, we have sent you a link to reset the password.',
    loginResetSinCorreo: 'Type your email above and click again.',
    loginErrReciente: 'For security, sign in with Google again and repeat this step.',
    tutoStepPresuTitle: 'Set up your budget 🧮',
    tutoStepPresuContent: 'Press "Unlock Editing" to change the monthly amount of each category (that is the estimate you will see in Tracking). The "+" on each block adds a category and, while editing is open, every row has a bin to remove it. Below, "One-time expenses" collects what does not repeat every month. When you are done, lock it again so nothing changes by accident.',
  },
  de: {
    // --- Landing: Kopfbereich ---
    landingNavFeatures: 'Funktionen',
    landingNavDashboard: 'Dashboard',
    landingNavHowItWorks: 'So funktioniert es',
    landingSignIn: 'Anmelden',
    // --- Landing: Hero ---
    landingHeroTitle1: 'Gestalten Sie Ihre',
    landingHeroTitle2: 'finanzielle Zukunft',
    landingHeroText: 'Das ultimative Werkzeug, um Ihr persönliches Budget zu verwalten, Ihr Nettovermögen zu analysieren und mit klaren Daten und aussagekräftigen Visualisierungen finanzielle Freiheit zu erreichen.',
    landingRegisterFree: 'Kostenlos registrieren',
    // --- Landing: Funktionen ---
    landingFeaturesTitle1: 'Leistungsstarke und',
    landingFeaturesTitle2: 'klare Werkzeuge',
    landingFeaturesText: 'Funktionen, die jede finanzielle Entscheidung klüger und einfacher machen.',
    landingFeat1Title: 'Flexible Budgets',
    landingFeat1Text: 'Legen Sie Jahresbudgets mit anpassbaren Kategorien und Unterkategorien fest. Berechnen Sie Ihren monatlichen "Restbetrag" und passen Sie Ihre Ausgaben jederzeit an – für volle Kontrolle.',
    landingFeat2Title: 'Nettovermögensanalyse',
    landingFeat2Text: 'Erfassen Sie Ihre Vermögenswerte und Verbindlichkeiten Monat für Monat. Verfolgen Sie die Entwicklung Ihres Nettovermögens mit interaktiven Liniendiagrammen und erkennen Sie Trends und Ihren wahren Wohlstand.',
    landingFeat3Title: 'Detaillierte monatliche Verfolgung',
    landingFeat3Text: 'Erfassen Sie Ihre tatsächlichen Einnahmen und Ausgaben und vergleichen Sie sie sofort mit Ihrem Budget. Visualisieren Sie die Verteilung Ihrer Ausgaben mit Kreis- und Balkendiagrammen.',
    landingFeat4Title: 'Kredit- und Tilgungsverwaltung',
    landingFeat4Text: 'Sehen Sie den Tilgungsplan Ihrer Kredite. Leisten Sie Sondertilgungen und beobachten Sie, wie sie sich auf Ihren Saldo und die Laufzeit Ihrer Schulden auswirken.',
    // --- Landing: Dashboard-Vorschau ---
    landingPreviewTitle1: 'Ihre',
    landingPreviewTitle2: 'finanzielle Kommandozentrale',
    landingPreviewText: 'Eine intuitive, leistungsstarke Oberfläche mit allen wichtigen Informationen auf einen Blick. So sieht Kontrolle aus.',
    landingTabCharts: 'Diagramme',
    landingTabLoan: 'Beispielkredit',
    landingLoanSummary: 'Kredit: 150.000 € | 30 Jahre | 3,5 % Zinsen',
    landingNetWorthEvolution: 'Jährliche Entwicklung des Nettovermögens',
    landingExpenseDistribution: 'Ausgabenverteilung ({month})',
    landingMonthSummary: 'Monatsübersicht (Aktuell)',
    landingActualIncome: 'Tatsächliche Einnahmen:',
    landingActualExpenses: 'Tatsächliche Ausgaben:',
    landingRemainder: 'Restbetrag:',
    landingBudgetVsActual: 'Vergleich Budget vs. Ist ({month})',
    landingAmortizationSchedule: 'Tilgungsplan',
    landingLoanDisclaimer: '*Dies ist eine Beispielsimulation. Die App ermöglicht es Ihnen, eigene Kredite hinzuzufügen, ihren detaillierten Tilgungsplan anzuzeigen und Sondertilgungen zu erfassen.',
    // --- Landing: Beispieldiagramme ---
    landingNetWorth: 'Nettovermögen',
    landingAssets: 'Vermögenswerte',
    landingLiabilities: 'Verbindlichkeiten',
    landingPieEssential: 'Wesentliche Ausgaben',
    landingPieDiscretionary: 'Freiwillige Ausgaben',
    landingPieDebt: 'Schuldentilgung',
    landingPieSavings: 'Sparen',
    // --- Landing: Tabelle Budget vs. Ist ---
    landingColCategory: 'Kategorie',
    landingColBudgeted: 'Budgetiert',
    landingColActual: 'Ist',
    landingColDifference: 'Differenz',
    landingRowRent: 'Miete',
    landingRowFood: 'Lebensmittel',
    landingRowTransport: 'Transport',
    landingRowTotalExpenses: 'Gesamtausgaben',
    // --- Landing: Tilgungstabelle ---
    landingFixedMonthlyPayment: 'Feste Monatsrate: {amount}',
    landingColMonth: 'Monat',
    landingColInterest: 'Zinsen',
    landingColPrincipal: 'Tilgung',
    landingColAmortized: 'Getilgt',
    landingColPending: 'Restschuld',
    // --- Landing: So funktioniert es ---
    landingHowTitle1: 'Verwalten Sie Ihre Finanzen in',
    landingHowTitle2: '3 einfachen Schritten',
    landingHowText: 'Übernehmen Sie schnell, intuitiv und effektiv die Kontrolle über Ihr Geld – so wie in Ihrem Alltag.',
    landingStep1Title: '1. Legen Sie Ihr Budget fest',
    landingStep1Text: 'Passen Sie Ihre Kategorien und Unterkategorien an. Weisen Sie Ihren erwarteten Einnahmen und Ausgaben für das Jahr Beträge zu.',
    landingStep2Title: '2. Erfassen Sie mühelos',
    landingStep2Text: 'Nutzen Sie das monatliche Schnellerfassungsformular, um Ihre täglichen Ausgaben und Einnahmen in Sekunden hinzuzufügen.',
    landingStep3Title: '3. Analysieren und wachsen',
    landingStep3Text: 'Sehen Sie Ihren Restbetrag, vergleichen Sie Ist mit Budget und beobachten Sie, wie Ihr Nettovermögen mit der Zeit wächst.',
    // --- Landing: Fußzeile ---
    landingFooterTagline: 'Behalten Sie Ihre finanzielle Zukunft im Griff.',

    // --- Login / Registrierung ---
    loginSubtitle: 'Verwaltung persönlicher Finanzen',
    loginSignIn: 'Anmelden',
    loginRegister: 'Registrieren',
    loginName: 'Name',
    loginNamePlaceholder: 'Ihr Name',
    loginEmail: 'E-Mail',
    loginEmailPlaceholder: 'beispiel@email.de',
    loginPassword: 'Passwort',
    loginRepeatPassword: 'Passwort wiederholen',
    loginLoading: 'Laden...',
    loginCreateAccount: 'Konto erstellen',
    loginOrSignInWith: 'ODER ANMELDEN MIT',
    loginBackHome: '← Zurück zur Startseite',
    loginErrFirebaseNotReady: 'Firebase Auth/DB noch nicht initialisiert',
    loginErrBadCredentials: 'Falsche Anmeldedaten. Überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.',
    loginErrPasswordLength: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    loginErrPasswordMismatch: 'Die Passwörter stimmen nicht überein.',
    loginErrEmailInUse: 'Diese E-Mail-Adresse ist bereits registriert. Bitte melden Sie sich an.',
    loginErrUnknown: 'Unbekannter Firebase-Fehler',
    loginErrAuth: 'Fehler bei der Authentifizierung: {msg}',
    loginErrFirebaseConfig: 'Firebase ist nicht korrekt konfiguriert. Prüfen Sie src/firebase.js',
    loginErrGoogle: 'Fehler bei der Anmeldung mit Google: {msg}',

    // --- Tutorial ---
    tutoStep1Title: 'Seitenmenü der Bereiche 🧭',
    tutoStep1Content: 'Die gesamte Navigation ist in Module gegliedert. Von hier aus erreichen Sie die Monatserfassung, Jahresbilanzen, Einstellungen und Vermögensrechner mit Zinseszins.',
    tutoStep2Title: 'Zeit ist der Schlüssel ⏳',
    tutoStep2Content: 'Dieser Selektor reist durch die Zeit. Wählen Sie das Jahr, in dem Sie arbeiten möchten. Standardmäßig werden Daten 10 Jahre in die Vergangenheit oder Zukunft projiziert, sofern Sie dort gearbeitet haben. Nutzen Sie die Zeit klug, um Budgets zu simulieren.',
    tutoStep3Title: 'Ihr Dashboard, ganz nach Ihrem Geschmack 🧩',
    tutoStep3Content: 'Klicken Sie auf "Anpassen", um festzulegen, welche Blöcke Sie in welcher Reihenfolge und Größe sehen: finanzielle Gesundheit, angesammelte Ersparnisse gegenüber dem Plan, jährliches Sparziel, wohin das Geld fließt, die Entwicklung einer Kategorie oder der Vergleich mit dem Vorjahr. Die Anordnung wird in Ihrem Konto gespeichert und ist auf jedem Gerät gleich.',
    tutoStep4Title: 'Budget und Verfolgung 📊',
    tutoStep4Content: 'Die Monatsübersicht hat oben zwei Reiter: Verfolgung (Ist-Werte, Monat für Monat) und Budget (der Plan für das Jahr, mit seinen Kategorien und Einmalausgaben). Klicken Sie auf "Budget", um fortzufahren und zu sehen, wie es sich ändert.',
    tutoStep5Title: 'Tag für Tag (Der monatliche Fluss) 📅',
    tutoStep5Content: 'Ihre "Patientenakte" des Monats, alles in einer Tabelle: Klicken Sie auf den Ist-Wert einer Kategorie und geben Sie die Summe ein (eine Buchung wird angelegt oder angepasst, damit es passt), und klicken Sie auf den Namen der Kategorie (▸), um ihre Buchungen zu sehen, mit Datum, Notiz und Betrag anzulegen, zu bearbeiten oder zu löschen. Die Schätzung ist Ihr Budget und wird im Reiter Budget dieses Bereichs bearbeitet.',
    tutoStep6Title: 'Vermögenswerte, Verbindlichkeiten und Ersparnisse 🏦',
    tutoStep6Content: 'Das ist keine alltägliche Ausgabe, sondern das Inventar dessen, was Sie besitzen und schulden! Speichern Sie hier Ihren Kontostand oder den Wert Ihrer Immobilie und verfolgen Sie, wie Sie mit der Zeit wohlhabender werden.',
    tutoStep7Title: 'Intelligente Kategorien ⚙️',
    tutoStep7Content: 'In den "Einstellungen" gelten das Erstellen oder Löschen von Kategorien NUR ab dem ausgewählten Jahr. So bleibt Ihre Vergangenheit unverändert geschützt. Dem klassischen System weit überlegen.',
    tutoStep8Title: 'Fügen Sie Ihre eigenen Daten hinzu! 🚀',
    tutoStep8Content: 'Damit FinanziApp ihr Potenzial entfaltet, legen Sie zunächst Ihre Grenzen im Budget fest, aktualisieren Sie Ihre Salden im Nettovermögen und richten Sie das Dashboard mit den Blöcken ein, die Sie interessieren. Sie steuern Ihre Finanzen!',
    tutoStepOf: 'SCHRITT {n} VON {total}',
    tutoSkip: 'Überspringen',
    tutoBack: 'Zurück',
    tutoLetsGo: "Los geht's!",
    tutoNext: 'Weiter',
    tutoInteract: 'Interagieren Sie, um fortzufahren',
    // ─── Professionelle Registrierung: Verifizierung, Passwort mit Google, Wiederherstellung ───
    loginCompletarTitulo: 'Registrierung abschließen',
    loginCompletarTexto: 'Zum Schutz Ihres Kontos legen Sie ein Passwort fest. So können Sie sich auch mit Ihrer E-Mail anmelden, wenn Sie Google nicht nutzen.',
    loginCompletarBtn: 'Speichern und anmelden',
    loginCancelar: 'Abbrechen',
    loginVerificarTitulo: 'E-Mail bestätigen',
    loginVerificarTexto: 'Wir haben eine E-Mail an {email} mit einem Link zur Aktivierung Ihres Kontos gesendet. Öffnen Sie ihn und kommen Sie hierher zurück: Sie werden automatisch angemeldet. Prüfen Sie auch den Spam-Ordner.',
    loginVerificarComprobar: 'Ich habe bestätigt',
    loginVerificarReenviar: 'E-Mail erneut senden',
    loginVerificarReenviado: 'E-Mail erneut gesendet. Prüfen Sie auch den Spam-Ordner.',
    loginVerificarPendiente: 'Noch nicht als bestätigt erkannt. Öffnen Sie den Link in der E-Mail und versuchen Sie es erneut.',
    loginVerificarOtra: 'Anderes Konto verwenden',
    loginOlvide: 'Passwort vergessen?',
    loginResetEnviado: 'Falls diese E-Mail ein Konto hat, haben wir Ihnen einen Link zum Zurücksetzen des Passworts gesendet.',
    loginResetSinCorreo: 'Geben Sie oben Ihre E-Mail ein und klicken Sie erneut.',
    loginErrReciente: 'Melden Sie sich aus Sicherheitsgründen erneut mit Google an und wiederholen Sie diesen Schritt.',
    tutoStepPresuTitle: 'Budget einrichten 🧮',
    tutoStepPresuContent: 'Drücken Sie „Bearbeitung freigeben“, um den Monatsbetrag jeder Kategorie zu ändern (das ist der Sollwert in der Verfolgung). Das „+“ jedes Blocks fügt eine Kategorie hinzu, und bei offener Bearbeitung hat jede Zeile einen Papierkorb zum Entfernen. Unten sammelt „Einmalige Ausgaben“, was sich nicht monatlich wiederholt. Sperren Sie danach wieder, damit sich nichts versehentlich ändert.',
  }
};
